import React, { FC, useEffect } from 'react';
import {
  DialogContent,
  InputLabel,
  TextField,
  Paper,
  Box,
  FormControlLabel,
  Checkbox,
  Divider,
} from '@material-ui/core';
import {Devices, GalleryImage } from '../../../api/infomodul/models';
import { Autocomplete } from '@material-ui/lab';

type Props = {
  deviceData: Devices[];
  galleryData: GalleryImage[];
  Duration: React.Dispatch<React.SetStateAction<any>>;
  selectedImagesId: React.Dispatch<React.SetStateAction<number[] | undefined>>;
  imgNames: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  devicesForSlideshow: React.Dispatch<React.SetStateAction<string[] | undefined>>;
  deviceNumbersForSlideshow: React.Dispatch<React.SetStateAction<number[]>>;
};

const CreateSlideshow: FC<Props> = ({
  deviceData,
  galleryData,
  Duration,
  selectedImagesId,
  imgNames,
  devicesForSlideshow,
  deviceNumbersForSlideshow
  
}) => {
  const [duration, setDuration] = React.useState<number | any>(20);
  const [selectedDevices, setSelectedDevices] = React.useState<Devices[]>(
    []
  );
  const [selectedImages, setSelectedImages] = React.useState<GalleryImage[]>(
    []
  );
  const [selectAllDevices, setSelectAllDevices] = React.useState<boolean>(false);
  const [imgDescriptions, setImgDescriptions] = React.useState<GalleryImage[]>([]);
  const [selectAllImages, setSelectAllImages] = React.useState<boolean>(false);
  const [types, setTypes] = React.useState<String[]>(["Pauseskærm", "Reklame"]); //SKAL ÆNDRES TIL PAUSESKÆRM
  const [imgDiff, setImgDiff] = React.useState<number | any>(null);


  //Selected image type - Reklame, Pauseskaerm
  const [selectedType, setSelectedType] = React.useState<string>();

//update selected devices
  useEffect(() => {
    const selectedDevicesHashes: string[] | undefined = [];
    const selectedDevicesNumbers: number[] | undefined = [];
    for (let i = 0; i < selectedDevices.length; i++) {
      selectedDevicesHashes.push(selectedDevices[i].clientHash);
      selectedDevicesNumbers.push(selectedDevices[i].deviceNumber);
    }
    devicesForSlideshow(selectedDevicesHashes);
    deviceNumbersForSlideshow(selectedDevicesNumbers);
  }, [selectedDevices]);

//updates selected images, and checks how many images are left
  useEffect(() => {
    const imgDifference = imgDescriptions.length - selectedImages.length;
    setImgDiff(imgDifference);
    const selectedImgIds: number[] | undefined = [];
    const selectedImgNames: string[] | undefined = [];
      selectedImages.map((element : any) => {
        selectedImgIds.push(element.id);
        selectedImgNames.push(element.imgName);
    })
    selectedImagesId(selectedImgIds);
    imgNames(selectedImgNames)
  }, [selectedImages]);

  //Gets duration, even if the user didnt input another duration
  useEffect(() => {
    getDuration();
  }, [])
  
//Set default duration
  const getDuration = () => {
    setDuration(duration);
    Duration(duration);
  };

  //Set selected devices
  const handleDeviceChange = (newSelection: Devices[] | null) => {
    if (newSelection) {
      setSelectedDevices(newSelection);
    } else {
      setSelectedDevices([]);
    }
  };

  //Set selected images
  const handleImageChange = (newSelection: GalleryImage[] | null) => {
    if (newSelection) {
      setSelectedImages(newSelection);
    } else {
      setSelectedImages([]);
    }
  };

//Selects all devices 
  const handleToggleSelectAllDevices = () => {
    setSelectAllDevices((prev) => {
      if (!prev) {
        setSelectedDevices([...deviceData]);
      } else {
        setSelectedDevices([]);
      }
      return !prev;
    });
  };

  //Selects all images
  const handleToggleSelectAllImages = () => {
    if (selectedType != null)
    {
      let filteredData : any;
      if(selectedType == 'Pauseskærm')
      {
        filteredData = galleryData.filter(name => name.type.toLowerCase() === 'Pauseskaerm'.toLowerCase());
      }
      else {
        filteredData = galleryData.filter(name => name.type.toLowerCase() === selectedType.toLowerCase());
      }
      setSelectAllImages((prev) => {
        if (!prev) {
          setSelectedImages([...filteredData]);
        } else {
          setSelectedImages([]);
        }
        return !prev;
      });
    }
  };

//Set duration of the slideshow
  const handleChangeDuration = (value: number | any) => {
    if (value !== null) {
      setDuration(value);
      Duration(value);
    }
  };

  //Checks if duration is a number
  const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value);
    if (!isNaN(value)) {
      handleChangeDuration(value);
    }
  };

//Changes the image type - 'Reklame' or 'Pauseskaerm'
  const handleTypeChange = (type: any) => {
    setSelectedType(type);
    setSelectedImages([]);
    setSelectAllImages(false);


  
    // Filter the data based on the selected type
    if (type !=null)
    {
      if (type == 'Pauseskærm')
      {
        type = 'Pauseskaerm';
        const filteredData = galleryData.filter(name => name.type.toLowerCase() === type.toLowerCase());
        setImgDescriptions(filteredData);
      } else {
        const filteredData = galleryData.filter(name => name.type.toLowerCase() === type.toLowerCase());
        // Set the filtered data to imgDescriptions state
        setImgDescriptions(filteredData);
      }
    }
    //Empty the array, so no images show up when type is null
    else {
      setImgDescriptions([]);
    }
  
  };

  return (
    <DialogContent style={{ overflow: "hidden" }}>
      <TextField
        value={duration || undefined}
        type='number'
        inputProps={{ min: 10, max: 60}}
        label="Varighed af billedfremvisning i sekunder"
        required
        onChange={handleTextFieldChange}
        error={duration && duration < 10 || duration && duration > 60}
        style={{ paddingBottom: 10 + "px", width: 100 + '%', paddingTop: 5 + 'px'}}
      />
      <InputLabel
        id="select-location-label"
        style={{ paddingBottom: 10 + 'px', paddingTop: 10 + 'px', width: 400 + 'px'}}
      >
        Vælg billede type
      </InputLabel>
      <Autocomplete
        // multiple
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Billede Type'}
            variant="outlined"
            fullWidth
          />
        )}
        options={types}
        value={selectedType || null}
        filterSelectedOptions
        noOptionsText={"Ingen billeder med typen 'Reklame' eller 'Pauseskærm'"}
        limitTags={3}
        onChange={(event, type) => {
          handleTypeChange(type);
        }}
        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              <Box
                onMouseDown={(e) => e.preventDefault()} // prevent blur
                pl={1.5}
                py={0.5}
              >
              </Box>
              <Divider />
              {children}
            </Paper>
          );
        }}
      />

      <InputLabel
        id="select-location-label"
        style={{ paddingBottom: 10 + 'px', paddingTop: 10 + 'px' }}
      >
        Vælg billeder for slideshow
      </InputLabel>
      <Autocomplete
        multiple
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Billeder'}
            variant="outlined"
            fullWidth
          />
        )}
        options={imgDescriptions}
        getOptionLabel={(option) => option.imgDescription}
        //If no images are left, close the options selection
        disableCloseOnSelect={imgDiff > 1}
        filterSelectedOptions
        noOptionsText={selectedType != null? "Ikke flere billeder": "Vælg billede type først"}
        limitTags={3}
        onChange={(event, newSelection) => {
          handleImageChange(newSelection);
        }}
        value={selectedImages}

        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              <Box
                onMouseDown={(e) => e.preventDefault()} // prevent blur
                pl={1.5}
                py={0.5}
              >
                {
                  imgDescriptions.length > 0 ?
                <FormControlLabel
                  onClick={(e) => {
                    handleToggleSelectAllImages();
                  }}
                  label="Vælg alle"
                  control={
                     <Checkbox id="select-all-checkbox" checked={selectAllImages} />
                  }
                />
                : <label></label>
              }
              </Box>
              <Divider />
              {children}
            </Paper>
          );
        }}
      />
      <InputLabel
        id="select-location-label"
        style={{ paddingBottom: 10 + 'px', paddingTop: 10 + 'px' }}
      >
        Vælg automater
      </InputLabel>
      <Autocomplete
        multiple
        renderInput={(params) => (
          <TextField
            {...params}
            label={'Automater'}
            variant="outlined"
            fullWidth
          />
        )}
        options={deviceData}
        getOptionLabel={(option) => option.deviceName}
        disableCloseOnSelect
        noOptionsText={"Ikke flere automater"}
        filterSelectedOptions
        limitTags={3}
        onChange={(slideshow, newSelection) => {
          handleDeviceChange(newSelection);
        }}
        value={selectedDevices}
        PaperComponent={(paperProps) => {
          const { children, ...restPaperProps } = paperProps;
          return (
            <Paper {...restPaperProps}>
              <Box
                onMouseDown={(e) => e.preventDefault()} // prevent blur
                pl={1.5}
                py={0.5}
              >
                <FormControlLabel
                  onClick={(e) => {
                    handleToggleSelectAllDevices();
                  }}
                  label="Vælg alle"
                  control={
                    <Checkbox id="select-all-checkbox" checked={selectAllDevices} />
                  }
                />
              </Box>
              <Divider />
              {children}
            </Paper>
          );
        }}
      />
    </DialogContent>
  );
};

export default CreateSlideshow;
